export default "__VITE_ASSET__BbJO1zlj__"